import React, { ReactNode } from 'react';

export interface MessageBubbleProps {
  id?: string;
  isSelf: boolean;
  isRepeat?: boolean;
  message: ReactNode;
  label?: string;
  avatarSrc?: string;
  avatarAlt?: string;
  avatarHref?: string;
}

export const MessageBubble = ({
  id,
  isSelf,
  isRepeat = false,
  message,
  label,
  avatarSrc,
  avatarAlt = '',
  avatarHref,
}: MessageBubbleProps): JSX.Element => {
  if (isSelf) {
    return (
      <div id={id} className='mb-4'>
        <div className='flex justify-end'>
          <div className='max-w-md'>
            <div className='bg-sapphire text-white rounded-lg px-4 py-2 whitespace-pre-line'>
              {message}
            </div>
            {label && <div className='text-xs text-right mt-1 mr-3'>{label}</div>}
          </div>
        </div>
      </div>
    );
  }

  const avatarNode =
    !isRepeat && avatarSrc ? (
      <img
        src={avatarSrc}
        alt={avatarAlt}
        className='w-8 h-8 rounded-full object-cover flex-shrink-0'
      />
    ) : (
      <div className='w-8 h-8 flex-shrink-0' />
    );

  return (
    <div id={id} className='mb-4'>
      <div className='flex gap-3'>
        {!isRepeat && avatarSrc && avatarHref ? (
          <a href={avatarHref}>{avatarNode}</a>
        ) : (
          avatarNode
        )}
        <div className='max-w-md'>
          <div className='bg-neutral-100 rounded-lg px-4 py-2 whitespace-pre-line'>
            {message}
          </div>
          {label && <div className='text-xs mt-1 ml-2'>{label}</div>}
        </div>
      </div>
    </div>
  );
};
